











import { apiBasicZoneLocationGetDistrictList } from '@/api'
import { computed, onMounted, ref } from '@vue/composition-api'
import { defineClassComponent } from '@/hooks'
import { TreeData } from 'vtils'

export default defineClassComponent<{
  value: boolean
  level?: number
}>(
  {
    props: ['value', 'level'],
  },
  ({ props, ctx }) =>
    class {
      constructor() {
        onMounted(() => {
          apiBasicZoneLocationGetDistrictList({})
            .then(res => {
              const tree = new TreeData<any>(res.list, {
                childrenPropName: 'childList',
              })
              tree.traverse(_ => {
                // 适配港澳台等两级地址
                if (_.depth === 1 && _.node.childList.length === 0) {
                  _.node.childList.push({
                    simpleName: '',
                    name: '',
                    code: '',
                  })
                }
              })
              tree.setDepth(this.divisionLevel.value - 1).setNodeProps({
                text: _ => _.node.simpleName,
                children: _ => _.node.childList,
              })
              return tree.export()
            })
            .then(res => {
              const gzIndex = res.findIndex(item =>
                item.name.includes('贵州'),
              )
              const gzItem = res[gzIndex]
              res.splice(gzIndex, 1)
              res.unshift(gzItem)
              this.divisionData.value = res
            })
        })
      }

      divisionLevel = computed(() => {
        return props.level || 3
      })

      pickerVisible = computed({
        get() {
          return props.value
        },
        set(visible) {
          ctx.$emit('input', visible)
        },
      })

      divisionData = ref<any[]>([])

      handleAddressPickerConfirm = (
        _: any,
        [provinceIndex, cityIndex, countyIndex]: any,
      ) => {
        const res = {
          province: this.divisionData.value[provinceIndex].name,
          provinceCode: this.divisionData.value[provinceIndex].code,
          city:
            this.divisionData.value[provinceIndex]?.children?.[cityIndex]
              ?.name || '',
          cityCode:
            this.divisionData.value[provinceIndex]?.children?.[cityIndex]
              ?.code || '',
          county:
            this.divisionData.value[provinceIndex]?.children?.[cityIndex]
              ?.children?.[countyIndex]?.name || '',
          countyCode:
            this.divisionData.value[provinceIndex]?.children?.[cityIndex]
              ?.children?.[countyIndex]?.code || '',
          district:
            this.divisionData.value[provinceIndex]?.children?.[cityIndex]
              ?.children?.[countyIndex]?.name || '',
          districtCode:
            this.divisionData.value[provinceIndex]?.children?.[cityIndex]
              ?.children?.[countyIndex]?.code || '',
        }
        ctx.$emit('pick', res)
        this.pickerVisible.value = false
      }
    },
)
